module.exports = __webpack_public_path__ + "static/media/orange_swish.13c611fe.svg";